module.exports = " <div class=input_box _v-08d1436f=\"\"> <input v-model=content type=\"{{ inputType }}\" placeholder=\"{{ hint }}\" _v-08d1436f=\"\"> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-08d1436f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/input-bundle/InputBox.vue
 ** module id = 331
 ** module chunks = 2
 **/